import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const NoAccessToInboxTooltip = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.routingRules.users.noAccess"
    }),
    children: children
  });
};
NoAccessToInboxTooltip.displayName = 'NoAccessToInboxTooltip';
export default NoAccessToInboxTooltip;